const root = "/server-licenses";

export const licenseIdRouteParam = "licenseId";

export const licenseRoutes = {
  root: root,
  detail: (licenseId: string) => ({
    root: `${root}/${licenseId}`,
  }),
  loadBySerial: (serialId: string) => ({
    root: `${root}/serial/${serialId}`,
  }),
};
